var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileUploadZeroState = function SvgFileUploadZeroState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#File_Upload_Zero_State_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.128 55.919v5.662H25.872V55.92H21.84v7.678c0 1.116.9 2.015 2.015 2.015h32.288c1.115 0 2.015-.9 2.015-2.015v-7.678h-4.03Z",
    fill: "#DC9B32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.531 30.503c0-5.222-4.247-9.469-9.468-9.469-1.21 0-2.372.235-3.432.647a12.068 12.068 0 0 0-11.09-7.294c-5.11 0-9.47 3.16-11.241 7.622a7.757 7.757 0 0 0-2.438-.375c-4.453 0-8.062 3.6-8.062 8.053 0 .657.075 1.313.244 1.922A9.453 9.453 0 0 0 10 39.981c0 5.222 4.247 9.46 9.478 9.46H60.531c5.232 0 9.469-4.238 9.469-9.46 0-5.24-4.237-9.478-9.469-9.478Z",
    fill: "#CAD9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.816 46.028a9.412 9.412 0 0 0 1.256-4.706 9.453 9.453 0 0 0-9.46-9.469c0-5.222-4.246-9.469-9.468-9.469a9.19 9.19 0 0 0-3.422.657c-1.856-4.294-6.131-7.294-11.1-7.294-3.816 0-7.2 1.753-9.413 4.51a11.998 11.998 0 0 1 10.341-5.842c4.969 0 9.234 2.991 11.09 7.294a9.273 9.273 0 0 1 3.432-.656c5.222 0 9.46 4.238 9.46 9.46C65.761 30.512 70 34.75 70 40a9.404 9.404 0 0 1-2.184 6.028Z",
    fill: "#9CB9DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.563 44.96 7.968-9.648L47.5 44.96h-3.855v10.977h-8.227V44.96h-3.855Z",
    fill: "#274673",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.881 45.522 40 35.519l8.119 10.003H44.19v11.381h-8.382V45.522h-3.928Z",
    fill: "#4376B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "File_Upload_Zero_State_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(10 10)",
    d: "M0 0h60v60H0z"
  })))));
};
export default SvgFileUploadZeroState;